// extracted by mini-css-extract-plugin
export default {"inProgressStatus":"CollaboratorOnboardingRequirements_inProgressStatus__Lu8mj","completeStatus":"CollaboratorOnboardingRequirements_completeStatus__0Q2VW"};